<template>
  <div>
    <Header :notHome="true" @goScroll="goScroll"></Header>
    <pageNav :navList="navList" :current="currentActive" title="业务领域" @navClick="navClick"></pageNav>
    <!-- 产品与服务 -->
    <div class="service-area" ref="area0">
      <div class="service-box">
        <b-container fluid>
          <b-row  class="page-model-title-row">
            <b-col xl="12">
              <div class="page-model-title-line flex justify-between align-center">
                <div class="page-model-title">
                  <span>01.</span>
                  <span>产品与服务</span>
                </div>
                <div class="page-model-right flex align-center" @click="goPage(0)" v-if="dataList[0]&&dataList[0].length!=0">
                  <span class="page-model-right-info d-sm-none d-xl-block">查看更多</span>
                  <span class="page-model-right-info d-sm-block d-xl-none">更多</span>
                  <img src="../../assets/image/icon8.png" />
                </div>
              </div>
            </b-col>
          </b-row>
          <b-row class="show-service-list page-middle-content-row">
            <!-- pc -->
            <b-col xl="4" v-for="(item, index) in dataList[0]" :key="index" class="d-sm-none d-xl-block" @click="goDetail(item,0)">
              <div class="service-item flex flex-column align-center">
                <div class="img-box flex align-center justify-center">
                  <img :src="$BaseUrl+item.image">
                </div>
                <div class="service-info flex flex-column justify-between">
                  <span class="overHidden2">{{item.title}}</span>
                  <span class="overHidden2">{{item.desc}}</span>
                </div>
              </div>
            </b-col>
            <!-- h5 -->
            <b-col sm="12" class="d-sm-block d-xl-none">
              <el-carousel indicator-position="inside" :autoplay="false" arrow="never" ref="swiper">
                <el-carousel-item v-for="(item,index) in dataList[0]" :key="index">
                  <div class="service-item flex flex-column align-center sm-service-item" @click="goDetail(item,0)">
                    <img :src="$BaseUrl+item.image">
                    <div class="service-content flex">
                      <div class="left-icon" @click.stop="changeSwiper(0)">
                        <img src="../../assets/image/icon11.png" />
                      </div>
                      <div class="sm-service-info flex flex-column justify-between">
                        <span class="overHidden">{{item.title}}</span>
                        <span class="overHidden2">{{item.desc}}</span>
                      </div>
                      <div class="right-icon" @click.stop="changeSwiper(1)">
                        <img src="../../assets/image/icon12.png" />
                      </div>
                    </div>
                  </div>
                </el-carousel-item>
              </el-carousel>
            </b-col>
          </b-row>
        </b-container>
      </div>
    </div>
    <!-- 技术与创新 -->
    <div class="technology-area" ref="area1">
      <div class="technology-box">
        <b-container fluid>
          <b-row class="page-model-title-row">
            <b-col xl="12">
              <div class="page-model-title-line flex justify-between align-center">
                <div class="page-model-title">
                  <span>02.</span>
                  <span>技术与创新</span>
                </div>
                <div class="page-model-right flex align-center" @click="goPage(1)" v-if="dataList[1]&&dataList[1].length!=0">
                  <span class="page-model-right-info d-sm-none d-xl-block">查看更多</span>
                  <span class="page-model-right-info d-sm-block d-xl-none">更多</span>
                  <img src="../../assets/image/icon8.png" />
                </div>
              </div>
            </b-col>
          </b-row>
          <b-row v-if="dataList[1]&&dataList[1].length!=0" class="page-middle-content-row">
            <b-col xl="6" sm="12">
              <div class="technology-item d-sm-none d-xl-block xl-technology-item" @click="goDetail(dataList[1][0],1)">
                <div class="flex justify-center align-center">
                  <img :src="$BaseUrl+dataList[1][0].image" />
                  <div class="technology-title">
                    <span class="overHidden2">{{dataList[1][0].title}}</span>
                  </div>
                </div>
              </div>
              <div class="technology-item d-sm-block d-xl-none sm-technology-item" @click="goDetail(dataList[1][0],1)">
                <div class="flex justify-center align-center">
                  <img :src="$BaseUrl+dataList[1][0].image" />
                  <!-- <div class="technology-title d-sm-none d-xl-block">
                                    <span class="overHidden2">技术创新标题技术创新标题技术创新标题技术创新标题技术创新标题</span>
                                </div> -->
                  <div class="d-sm-block d-xl-none">
                    <div class="technology-title">
                    <span class="overHidden">{{dataList[1][0].title}}</span>
                  </div>
                  </div>
                </div>
              </div>
            </b-col>
            <b-col xl="6" sm="12">
              <b-row class="sm-row">
                <div v-for="(item, index) in dataList[1].slice(1)" :key="index" class="technology-item spec-item" @click="goDetail(item,1)">
                  <div class="flex align-center justify-center">
                    <img :src="$BaseUrl+item.image" />
                    <div class="d-sm-none d-xl-block">
                    <div class="technology-title d-sm-none d-xl-block">
                      <span class="overHidden2">{{item.title}}</span>
                    </div>
                    </div>
                    <div class="d-sm-block d-xl-none">
                    <div class="technology-title d-sm-block d-xl-none">
                      <span class="overHidden">{{item.title}}</span>
                    </div>
                    </div>
                  </div>
                </div>
              </b-row>
            </b-col>
          </b-row>
        </b-container>
      </div>
    </div>
    <!-- 行业动向 -->
    <div class="dynamics-area" ref="area2">
      <div class="dynamics-box">
        <b-container fluid>
          <b-row class="page-model-title-row">
            <b-col xl="12">
              <div class="page-model-title-line flex justify-between align-center">
                <div class="page-model-title">
                  <span>03.</span>
                  <span>行业动向</span>
                </div>
                <div class="page-model-right flex align-center" @click="goPage(2)" v-if="dataList[2]&&dataList[2].length!=0">
                  <span class="page-model-right-info d-sm-none d-xl-block">查看更多</span>
                  <span class="page-model-right-info d-sm-block d-xl-none">更多</span>
                  <img src="../../assets/image/icon8.png" />
                </div>
              </div>
            </b-col>
          </b-row>
          <b-row class="page-middle-content-row">
            <b-col xl="12">
              <div class="dynamics-item flex" v-for="(item, index) in dataList[2]" :key="index" @click="goDetail(item,2)">
                <div class="dynamics-item-left flex align-center">
                  <div class="dynamics-item-date d-sm-none d-xl-block">
                    <div class="flex flex-column">
                      <span>{{item.showTime?item.showTime[0]:''}}</span>
                      <span>{{item.showTime?item.showTime[1]:''}}</span>
                    </div>
                  </div>
                  <div class="dynamics-item-content flex flex-column justify-between">
                    <div class="dynamics-item-title overHidden2">
                      {{item.title}}
                    </div>
                    <div class="dynamics-item-contentDate d-sm-block d-xl-none">
                      {{item.publishDate.substring(0,10).replace(/-/g,'/')}}
                    </div>
                    <!-- pc -->
                    <div class="dynamics-item-desc d-sm-none d-xl-block">
                      <div class="overHidden2">{{item.desc}}</div>
                    </div>
                    <!-- h5 -->
                    <div class="dynamics-item-desc d-sm-block d-xl-none">
                      <div class="overHidden">{{item.desc}}</div>
                    </div>
                  </div>
                </div>
                <div class="dynamics-item-img flex align-center justify-center">
                  <img :src="$BaseUrl+item.image" />
                </div>
              </div>
            </b-col>
          </b-row>
        </b-container>
      </div>
    </div>
    <Footer @goScroll="goScroll"></Footer>
  </div>
</template>
<script>
import { getBusinessList } from "@/api/bussiness"
export default {
  data() {
    return {
      navList: [{
        title: '产品与服务'
      }, {
        title: '技术与创新'
      }, {
        title: '行业动向'
      }],
      currentActive: 0,
      dataList: [[], [], []],
      topList:[],
      stopScroll:false,
      stopScrollTimeout:null
    }
  },
  mounted() {
    this.countViewCount()
    this.getBusiness()
  },
  destroyed(){
    window.removeEventListener("scroll", this.handleScroll)
  },
  methods: {
    getBusiness() {
      getBusinessList().then(res => {
        if (res.code == 200) {
          let temp = [[], [], []]
          res.data.forEach(v => {
            if (v.name == '产品与服务') {
              temp.splice(0, 1, v.list)
            } else if (v.name == '技术与创新') {
              temp.splice(1, 1, v.list)
            } else if (v.name == '行业动向') {
              temp.splice(2, 1, v.list)
            }
          })
          this.dataList = temp
          // this.dataList = [(res.data['产品和服务'] || []), (res.data['技术与创新'] || []), (res.data['行业动向'] || [])]
          if (this.dataList[0].length > 3) {
            this.dataList[0] = this.dataList[0].slice(0, 3)
          }
          if (this.dataList[1].length > 5) {
            this.dataList[1] = this.dataList[1].slice(0, 5)
          }
          if (this.dataList[2].length > 3) {
            this.dataList[2] = this.dataList[2].slice(0, 3)
          }
          this.dataList[0] = this.dataList[0].map(v => {
            v.desc = (v.content || '').replace(/<img.*?>/g, "").replace(/<\/?.+?\/?>/g, ' ')
            return v
          })
          this.dataList[2] = this.dataList[2].map(t => {
            let d = t.publishDate.substring(0, 10).split('-')
            t.showTime = [d[0], `${d[1]}-${d[2]}`]
            t.desc = (t.content || '').replace(/<img.*?>/g, "").replace(/<\/?.+?\/?>/g, ' ')
            return t
          })
          this.$nextTick(() => {
            if (this.$route.query.to != undefined) {
              this.navClick({ index: Number(this.$route.query.to) })
              setTimeout(()=>{
                window.addEventListener("scroll", this.handleScroll)
              },1000)
            }else{
              window.addEventListener("scroll", this.handleScroll)
            }
          })
        }
      })
    },
    navClick({ item, index }) {
      this.stopScroll=true
      if(this.stopScrollTimeout)clearTimeout(this.stopScrollTimeout)
      this.currentActive = index
      this.$nextTick(() => {
        setTimeout(() => {
          this.scrollByRef(`area${index}`)
        }, 100)
        this.stopScrollTimeout = setTimeout(() => {
          this.stopScroll = false
        }, 1100)
      })
    },
    changeSwiper(index) {
      // console.log(index)
      if (index == 1) {
        this.$refs.swiper.next()
      } else {
        this.$refs.swiper.prev()
      }
    },
    goPage(index) {
      let temp = this.dataList[index][0]
      this.$router.push({ path: '/newsList?categoryOne=' + temp.categoryOne + '&categoryTwo=' + temp.categoryTwo + '&type=bussiness&scroll=' + index })
    },
    goDetail(item, index) {
      let pageName = ['产品与服务', '技术与创新', '行业动向'][index]
      this.$router.push({ path: `/newsDetail?contentId=${item.contentId}&type=bussiness&=pageName=${pageName}&scroll=${index}` })
    },
    goScroll(index) {
      this.navClick({ index: Number(index) })
    },
    handleScroll(e){
      if(this.stopScroll){
        return
      }
      let nowTop = e.target.scrollTop || document.documentElement.scrollTop
      if(this.topList.length==0){
        for(let i=0;i<3;i++){
          this.topList.push(this.$refs[`area${i}`].offsetTop-200)
        }
      }
      let temp=this.currentActive
      let result=this.topList.reduce((res,curV,curVindex)=>{
        if(nowTop>=curV){
          res=curVindex
        }
        return res
      },temp)
      // 获取距离顶部的距离
      let scrollTop = document.documentElement.scrollTop||document.body.scrollTop;
      // 获取可视区的高度
      let windowHeight = document.documentElement.clientHeight || document.body.clientHeight;
      // 获取滚动条的总高度
      let scrollHeight = document.documentElement.scrollHeight||document.body.scrollHeight;
      if(scrollTop+windowHeight>=scrollHeight){
        // 把距离顶部的距离加上可视区域的高度 等于或者大于滚动条的总高度就是到达底部                    
        result=this.topList.length-1
      }
      this.currentActive=result
      // console.log(this.topList)
    }
  }
}
</script>
<style lang="scss" scoped>
// 产品与服务
.service-area {
  background-image: url("../../assets/image/bg11.png");
  background-size: cover;
  width: 100%;
  min-height: 455px;
  padding-bottom: 60px;
  padding-top: 60px;
  .show-service-list{
    margin-top: 30px;
    >div{
      padding: 0;
    }
  }

  .service-box {
    max-width: 1200px;
    margin: 0 auto;

    .service-item {
      // margin-top: 30px;
      width: 100%;
      .img-box {
        // width: 285px;
        width: calc(100% - 15px);
        height: 214px;
        background: #fff;
      }
      img {
        // width: 285px;
        width: 100%;
        object-fit: cover;
        height: 214px;
      }

      .service-info {
        margin-top: -40px;
        // width: 255px;
        width: calc(100% - 45px);
        min-height: 186px;
        padding: 15px;
        z-index: 5;
        position: relative;
        background: rgba(255, 255, 255, 0.6);
        backdrop-filter: blur(1px);
        cursor: pointer;

        > span:first-of-type {
          font-family: "SourceHanSansCN-Regular";
          font-weight: bold;
          font-size: 24px;
          color: #333333;
          line-height: 36px;
        }

        > span:last-of-type {
          font-family: "SourceHanSansCN-Regular";
          font-weight: 400;
          font-size: 20px;
          color: #666666;
          line-height: 30px;
        }
      }

      .service-info:hover {
        background-color: #1566d4;
        > span:first-of-type {
          color: #fff;
        }

        > span:last-of-type {
          color: rgba(255, 255, 255, 0.6);
        }
      }
    }

    /deep/.el-carousel__container {
      height: auto;
      min-height: 500px;
    }

    .sm-service-item {
      width: 100%;
      > img {
        width: 702px;
        min-height: 396px;
      }

      .service-content {
        align-items: flex-end;
        margin-top: -120px;
        width: 100%;

        .sm-service-info{
          padding-bottom: 30px!important;
        }

        .left-icon {
          width: 88px;
          height: 88px;
          flex-shrink: 0;

          img {
            max-width: 88px;
            max-height: 88px;
          }
        }

        .right-icon {
          width: 88px;
          height: 88px;
          flex-shrink: 0;

          img {
            max-width: 88px;
            max-height: 88px;
          }
        }

        .sm-service-info {
          min-height: 186px;
          background: #1566d4;
          flex: 1;
          min-width: 0;
          padding: 20px;

          > span:first-of-type {
            font-family: "SourceHanSansCN-Regular";
            font-weight: bold;
            font-size: 26px;
            color: #ffffff;
            line-height: 39px;
          }

          > span:last-of-type {
            font-family: "SourceHanSansCN-Regular";
            font-weight: 400;
            font-size: 24px;
            color: rgba(255, 255, 255, 0.8);
            line-height: 36px;
          }
        }
      }
    }
  }
}

// 技术与创新
.technology-area {
  background-image: url("../../assets/image/bg10.png");
  background-size: cover;
  width: 100%;
  min-height: 444px;
  padding-bottom: 60px;
  padding-top: 60px;

  .technology-box {
    max-width: 1200px;
    margin: 0 auto;

    .page-model-title-line {
      margin-bottom: 30px;
    }
    .technology-item {
      width: 580px;
      max-height: 336px;
      position: relative;
      overflow: hidden;
      cursor: pointer;
      box-sizing: border-box;
      > div {
        width:100%;
        overflow: hidden;
        background: #fff;
      }
      img {
        width: 100%;
        object-fit: cover;
        // max-width: 495px;
        height: 336px;
      }

      .technology-title {
        position: absolute;
        width: 100%;
        overflow: hidden;
        bottom: 0;
        left: 0;
        padding: 20px 15px;
        font-family: "SourceHanSansCN-Regular";
        font-weight: bold;
        font-size: 24px;
        color: #ffffff;
        line-height: 30px;
        box-sizing: border-box;
        text-overflow: ellipsis;
        overflow: hidden;
        background: linear-gradient( 180deg, rgba(0,0,0,0) 0%, rgba(0,0,0,0.5) 100%);
      }
    }

    .xl-technology-item{
      height: 336px;
    }

    .left-item {
      margin-top: 30px;
    }

    .sm-technology-item {
      width: 100%;
      height: 600px;
      overflow: hidden;
      margin-bottom: 15px;
      // margin-top: 30px;

      img {
        // width: 100%;
        width: 100%;
        object-fit: cover;
        height: 600px;
      }
    }

    .spec-item {
      padding-left: 0;
      padding-right: 0;
      margin-bottom: 15px;
      margin-left: 20px;
      // width: 280px;
      width: calc(50% - 20px);
      overflow: hidden;
      > div {
        // width: 280px;
        width: 100%;
      }
      .technology-title{
        // width: 280px;
      }
      img {
        // min-height: 100%;
        // max-width: 270px;
        // width: 280px;
        width: 100%;
        object-fit: cover;
        height: 158px;
      }
    }

    .sm-row {
      // padding: 0 15px;
      // margin-left: 20px;
    }
  }
}

// 行业动向
.dynamics-area {
  background-image: url("../../assets/image/bg9.png");
  background-size: cover;
  width: 100%;
  min-height: 700px;
  padding-bottom: 60px;
  padding-top: 60px;

  .dynamics-box {
    max-width: 1200px;
    margin: 0 auto;

    .dynamics-item {
      width: 100%;
      background: #fff;
      margin-bottom: 15px;
      box-shadow: 0px 0 23px 0px rgba(10, 49, 128, 0.1);
      // border: 1px solid rgba(153, 153, 153, 0.5);
      overflow: hidden;
      cursor: pointer;

      .dynamics-item-left {
        padding: 20px 0;
        flex: 1;
        min-width: 0;
        overflow: hidden;
      }

      &-date {
        padding: 35px 0;
        min-width: 170px;
        border-right: 3px solid rgba(153, 153, 153, 0.5);
        flex-shrink: 0;

        > div {
          > span:first-of-type {
            text-align: center;
            font-family: "SourceHanSansCN-Regular";
            font-weight: bold;
            font-size: 33px;
            color: #333333;
            line-height: 41px;
          }

          > span:last-of-type {
            text-align: center;
            font-family: "SourceHanSansCN-Regular";
            font-weight: 400;
            font-size: 22px;
            color: #666666;
            line-height: 25px;
          }
        }
      }

      &-content {
        height: 174px;
        padding: 10px 20px;
        flex: 1;
        min-width: 0;
        overflow: hidden;

        .dynamics-item-title {
          font-family: "SourceHanSansCN-Regular";
          font-weight: bold;
          font-size:  24px;
          color: #333333;
          // min-height: 51px;
        }

        .dynamics-item-contentDate {
          font-family: "SourceHanSansCN-Regular";
          font-weight: 400;
          font-size: 20px;
          color: #999999;
        }

        .dynamics-item-desc {
          font-family: "SourceHanSansCN-Regular";
          font-size: 20px;
          color: #666666;
          min-height: 64px;
          overflow: hidden;
          // span{
          //   display: inline-block;
          //   width: 100%;
          // }
        }
      }

      &-img {
        width: 380px;
        height: 214px;
        flex-shrink: 0;

        img {
          width: 380px;
          height: 214px;
          object-fit: cover
        }
      }
    }

    .dynamics-item:first-of-type {
      margin-top: 30px;
    }

    .dynamics-item:last-of-type {
      margin-bottom: 0;
    }

    .dynamics-item:hover {
      background-color: #1566d4;

      .dynamics-item-date {
        > div {
          > span:first-of-type {
            color: #fff;
          }

          > span:last-of-type {
            color: rgba(255, 255, 255, 0.6);
          }
        }
      }

      .dynamics-item-content {
        .dynamics-item-title {
          color: #fff;
        }

        .dynamics-item-desc {
          color: rgba(255, 255, 255, 0.7);
        }
      }
    }
  }
}

// 移动端
@media (min-width: 576px) and (max-width: 1200px) {
// 产品与服务
.service-area{
   .service-content{
    margin-top: -50px!important;
   }
   /deep/.el-carousel__container{
    height: 540px!important;
   }
}
// 技术与创新
.technology-area{
  .technology-title{
    font-size: 26px!important;
    background: linear-gradient( 180deg, rgba(21,102,212,0) 0%, rgba(21,102,212,0.5) 100%)!important;   
    box-shadow: 0px 0px 30px 0px rgba(10,49,128,0.1)!important;  
    min-height: 100px;
    align-items: flex-end;
    display: flex;
    
  }
  .sm-technology-item{
    height: 396px!important;
    max-height: 396px!important;
    >div{
      width: 100%;
      // max-width: 702px;
      margin: 0 auto;
      height: 396px!important;
      img{
        width: 100%;
        height: 396px!important;
      }
    }
  }
  .spec-item{
    height: 192px!important;
    max-height: 192px!important;
    margin-top: 5px;
    .technology-title{
      min-height: 100px!important;
    align-items: flex-end!important;
    display: flex!important;
    }
    >div{
      // max-width: 341px;
      height: 192px!important;
      img{
        // max-width: 341px;
      height: 192px!important;
      }
    }
  }
}
// 行业动向
// 培训学习
.dynamics-area{
  .dynamics-box{
    .dynamics-item{
      height: 192px;
        .dynamics-item-img{
          width: 341px!important;
          height: 192px!important;
          img{
            width: 341px!important;
          height: 192px!important;
          }
        }
        .dynamics-item-content{
          .dynamics-item-title{
            font-size: 26px;
            min-height: 78px;
          }
          .dynamics-item-contentDate{
            font-size: 20px;
          }
          .dynamics-item-desc{
            font-size: 24px;
            min-height: 0;
          }
        }
    }
  }
}
}
</style>